import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { BASE_IMAGES_URL, ACCESS_FILES_API_KEY } from "Constants";
import {
  deleteSponsorCategory,
  openSponsorModal,
  editSponsorCategory,
} from "ActionsSponsors";
import { checkContentDashboardStatus } from "GeneralTabAction";
import { showError, showSuccess } from "ReduxErrorBar";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import LocaleStrings from "Languages";

class CategoryListItem extends Component {
  deleteCategoryCallback(sponsor) {
    let pageNo = this.props.currentPage;
    if (this.props.pageDataLength == 1) {
      pageNo = pageNo - 1;
    }

    confirmAlert({
      title: "Delete",
      message:
        "This will delete related sponsors too, are you sure to proceed?",
      confirmLabel: "OK",
      cancelLabel: "CANCEL",
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            var categoryid = this.props.category.id;
            this.props.deleteSponsorCategory(
              this.props.session,
              categoryid,
              (result) => {
                if (result.error) {
                  this.props.showError("Something went wrong, try again.!");
                } else {
                  this.props.showSuccess(
                    "Category deleted with related sponsors successfully "
                  );
                  this.props.checkContentDashboardStatus(this.props.session);
                  this.props.pagination(pageNo);
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  editCategoryCallback(obj) {
    var cat = { ...this.props.category, toAdd: false, toEdit: true };
    this.props.editSponsorCategory(cat);
  }

  render() {
    var { category } = this.props;

    var tagURL = "";
    if (category.membershiptype == "bronze") {
      tagURL = "../../style/images/custom-icons/bronze.svg";
    } else if (category.membershiptype == "silver") {
      tagURL = "../../style/images/custom-icons/silver.svg";
    } else if (category.membershiptype == "gold") {
      tagURL = "../../style/images/custom-icons/gold.svg";
    } else if (category.membershiptype == "platinum") {
      tagURL = "../../style/images/custom-icons/platinum.svg";
    } else {
      tagURL = "../../style/images/custom-icons/test.svg"; //icon haven't implemented yet
    }

    let width =
      _.size(category.membershiptitle) * 10 < 97
        ? 97
        : _.size(category.membershiptitle) * 12;

    let catNameStyle = {
      position: "relative",
      right: width,
      color: category.textcolor,
    };

    return (
      <tr key={category.id}>
        <td>
          <div className="vcenter">
            {/* <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="97" height="29">
              <svg xmlns="http://www.w3.org/2000/svg" width={width} height="29">
                <path
                  fill={category.bgcolor}
                  fillRule="evenodd"
                  d="M88.362 12.578c-1.049 1.061-1.049 2.783 0 3.845l7.845 7.936c1.693 1.713.494 4.641-1.9 4.641H5c-2.761 0-5-2.239-5-5V5c0-2.761 2.239-5 5-5h89.307c2.394 0 3.593 2.928 1.9 4.641l-7.845 7.937z"
                />
              </svg>
              <span style={catNameStyle}>
                {category.membershiptitle.toUpperCase()}
              </span>
            </div> */}

            {/* <img className="i-custom-membership" src={tagURL} /> */}
            <div className="shape-left">
              <div className="triangle-left"></div>
              <div
                className="square-left"
                style={{
                  color: category.textcolor,
                  background: category.bgcolor,
                }}
              >
                {category.membershiptitle.toUpperCase()}
              </div>
            </div>
          </div>
        </td>
        <td>
          <div className="action-button-area">
            <div className="action-button vcenter">
              <button
                className="btn btn-custom-table-white"
                onClick={this.editCategoryCallback.bind(this)}
              >
                Edit
              </button>
            </div>
            <div className="action-button vcenter">
              <button
                className="i-custom-table-delete"
                onClick={this.deleteCategoryCallback.bind(this)}
              >
                <img
                  className="button-delete-icon"
                  src="../../style/images/delete.png"
                />
              </button>
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {
  deleteSponsorCategory,
  editSponsorCategory,
  showError,
  showSuccess,
  checkContentDashboardStatus,
})(CategoryListItem);
